export function generateMailtoLink(
  email: string,
  body?: string,
  subject?: string
) {
  const params: string[] = []
  if (body) {
    params.push(`body=${encodeURIComponent(body)}`)
  }
  if (subject) {
    params.push(`subject=${encodeURIComponent(subject)}`)
  }
  const paramString = params.length ? `?${params.join('&')}` : ''
  return `mailto:${email}${paramString}`
}
